<template>
  <div>
    <Modal
      v-model="addTwoIntentionShow"
      :styles="{ top: '20px', width: '800px' }"
      title="创建二次签单意向"
      :mask-closable="false"
      :closable="false"
    >
      <Alert type="error"
        >创建二次签单意向后，客户将出现在您的跟进客户列表</Alert
      >
      <Form
        ref="formValidate"
        :model="formItem"
        :rules="ruleValidate"
        :label-width="80"
      >
        <div class="title">
          <h3>基本信息</h3>
        </div>
        <Row>
          <Col span="12">
            <FormItem label="姓名" prop="member.name">
              <Input
                v-model="formItem.member.name"
                placeholder="请输入"
              ></Input>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="新预产期" prop="member.child_birth">
              <DatePicker
                v-model="formItem.member.child_birth"
                type="date"
                placeholder="请选择"
                style="display: block"
              ></DatePicker>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="12">
            <FormItem label="咨询日期" prop="member.consult_time">
              <DatePicker
                v-model="formItem.member.consult_time"
                type="date"
                placeholder="请选择"
                style="display: block"
              ></DatePicker>
            </FormItem>
          </Col>
          <!-- <Col span="12">
                        <FormItem label="分娩医院" prop="member.hospital">
                            <Input v-model="formItem.member.hospital"  placeholder="请输入"></Input>
                        </FormItem>
                    </Col> -->
          <Col span="12">
            <FormItem label="分娩医院" prop="member.hospital">
              <Select
                v-model="formItem.member.hospital"
                filterable
                remote
                clearable
                @on-query-change="remoteMethod"
                :remote-method="remoteMethod1"
                :loading="remoteLoading"
              >
                <Option
                  v-for="(option, index) in hospitalList"
                  :key="index"
                  :value="option.label"
                  :label="option.label"
                >
                  <span>{{ option.label }}</span>
                  <span style="float: right; color: #ccc">{{
                    option.value
                  }}</span>
                </Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="24">
            <FormItem label="备注" prop="member.remark">
              <Input
                v-model="formItem.member.remark"
                type="textarea"
                :maxlength="200"
                :autosize="{ minRows: 2, maxRows: 5 }"
                placeholder="200字(含)以内"
              ></Input>
            </FormItem>
          </Col>
        </Row>
        <div class="title">
          <h3>录入信息</h3>
        </div>
        <Row>
          <Col span="8">
            <FormItem label="录入系统" prop="channel_info.insert_way">
              <Select v-model="formItem.channel_info.insert_way">
                <Option
                  v-for="item in baseData.add_member_insert_way"
                  :value="item.id"
                  :key="item.id"
                  >{{ item.name }}</Option
                >
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="8">
            <FormItem label="渠道" prop="channel_info.department_id">
              <Select
                v-model="formItem.channel_info.department_id"
                placeholder="请选择部门"
                @on-change="changeChannel"
              >
                <Option
                  v-for="item in prop_departmentList"
                  :key="item.id"
                  :value="item.id + ''"
                  >{{ item.name }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem :label-width="0" prop="channel_info.channel_id">
              <Select
                v-model="formItem.channel_info.channel_id"
                filterable
                placeholder="请选择渠道"
              >
                <Option
                  v-for="item in channel"
                  :key="item.id"
                  :value="item.id + ''"
                  >{{ item.name }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col span="10">
            <FormItem :label-width="0" prop="channel_info.channel_explain">
              <Input
                v-model="formItem.channel_info.channel_explain"
                placeholder="请输入渠道说明"
              ></Input>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="24">
            <FormItem label="跟进门店" prop="follow_store[0].store_id">
              <Button type="primary" @click="addFollowStore">添加</Button>
              <span style="color:red;">(以下为一次签单的跟进结果，二次意向请另外添加)</span>
            </FormItem>
          </Col>
        </Row>
        <Row v-for="(item, index) in formItem.follow_store" :key="index">
          <Col span="5">
            <FormItem :label-width="0" prop="follow_store[0].store_id">
              <Select
                v-model="item.store_id"
                placeholder="请选择门店"
                :disabled="item.disabled"
                @on-change="follow_store_change"
              >
                <Option
                  v-for="v in prop_storeList"
                  :value="v.id + ''"
                  :key="v.id"
                  >{{ v.name }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col span="5">
            <FormItem :label-width="0" prop="follow_store[0].member_group_id">
              <Select
                v-model="item.member_group_id"
                :disabled="item.disabled"
                placeholder="请选择客户分组"
              >
                <Option
                  :v-if="prop_customerGroudList.length"
                  v-for="item in prop_customerGroudList"
                  :key="item.id"
                  :value="item.id + ''"
                  >{{ item.name }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col span="5">
            <FormItem :label-width="0" prop="follow_store[0].come_status">
              <Select
                v-model="item.come_status"
                :disabled="item.disabled"
                placeholder="请选择到店状态"
              >
                <Option
                  v-for="item in baseData.come_status"
                  :value="item.id"
                  :key="item.id"
                  >{{ item.name }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col span="5" v-if="item.come_status == '2'">
            <FormItem :label-width="0" prop="follow_store[0].return_setting_id">
              <Select
                v-model="item.return_setting_id"
                :disabled="item.disabled"
                placeholder="请选择到店方式"
              >
                <Option
                  v-for="item in prop_returnSettingList"
                  :value="item.id + ''"
                  :key="item.id"
                  >{{ item.return_info }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col span="5" v-if="item.come_status == '2'">
            <DatePicker
              v-model="item.come_date"
              format="yyyy-MM-dd"
              :disabled="item.disabled"
              placeholder="请选择到店时间"
              style="display: block"
            ></DatePicker>
          </Col>
          <Col :span="5">
            <Select
              placeholder="到店结果"
              v-if="item.come_status == '2'"
              :disabled="item.disabled"
              v-model="item.arrival_result_id"
            >
              <Option
                v-for="item in arrival_result"
                :value="item.id + ''"
                :key="item.id"
                >{{ item["result"] }}</Option
              >
            </Select>
          </Col>
          <Col :span="10">
            <Input
              v-if="item.come_status == '2' && item.arrival_result_id == '0'"
              v-model="item.other"
              :maxlength="20"
              placeholder="1-12个字符"
            ></Input
          ></Col>
          <Col span="9">
            <FormItem :label-width="0">
              <Button
                v-if="!item.type"
                type="primary"
                @click="editFollowStore(index)"
                style="margin-left: 5px"
                >修改</Button
              >
              <Button type="error" @click="delFollowStore(index, item.type)"
                >删除</Button
              >
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="24">
            <FormItem label="跟进人">
              <Button type="primary" @click="addFollow">添加</Button>
            </FormItem>
          </Col>
        </Row>
        <Row v-for="(item, index) in formItem.follow_agent" :key="index + '33'">
          <Col span="5">
            <FormItem :label-width="0">
              <Select
                v-model="item.store_id"
                :disabled="item.disabled"
                @on-change="changeStoreFollow(item.store_id, index, item.type)"
                placeholder="请选择门店"
              >
                <Option
                  v-for="v in get_follow_store_list"
                  :value="v.id"
                  :key="v.id"
                  >{{ v.name }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col span="5">
            <FormItem :label-width="0">
              <Select
                v-model="item.department_id"
                :disabled="item.disabled"
                @on-change="
                  changeDepartmentFollow(item.department_id, index, item.type)
                "
                placeholder="请选择部门"
              >
                <Option
                  v-for="item in followDepartmentList"
                  :key="item.id"
                  :value="item.id"
                  >{{ item.name }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col span="5">
            <FormItem :label-width="0">
              <Select
                v-model="item.follow_user"
                :disabled="item.disabled"
                placeholder="请选择跟进人"
              >
                <Option
                  v-for="kk in item.follow_user_data"
                  :value="kk.id"
                  :key="kk.id"
                  >{{ kk.user_name }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col span="9">
            <FormItem :label-width="0">
              <Button
                type="primary"
                v-if="!item.type"
                @click="editFollowInfo(index)"
                style="margin-left: 5px"
                >修改</Button
              >
              <Button type="error" @click="delFollow(index, item.type)"
                >删除</Button
              >
            </FormItem>
          </Col>
        </Row>
        <div class="title">
          <h3>家属信息</h3>
        </div>
        <Row>
          <Col span="24">
            <FormItem label="家属信息">
              <Button type="primary" @click="addFamily">添加</Button>
            </FormItem>
          </Col>
        </Row>
        <Row v-for="(item, index) in formItem.maternal_family" :key="item.id">
          <Col span="5">
            <FormItem :label-width="0">
              <Input v-model="item.name" placeholder="请输入姓名"></Input>
            </FormItem>
          </Col>
          <Col span="5">
            <FormItem :label-width="0">
              <Select v-model="item.relation" placeholder="请选择关系">
                <Option
                  v-for="item in baseData.family_relation"
                  :value="item.name"
                  :key="item.id"
                  >{{ item.name }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col span="5">
            <FormItem :label-width="0">
              <Input
                v-model="item.phone"
                :maxlength="11"
                placeholder="请输入手机号"
                @on-blur="familyPhoneChange(item.phone)"
              ></Input>
            </FormItem>
          </Col>
          <Col span="5">
            <FormItem :label-width="0">
              <Button type="error" @click="delFamily(index)">删除</Button>
            </FormItem>
          </Col>
        </Row>
      </Form>
      <div slot="footer">
        <Button type="text" size="large" @click="cancel">取消</Button>
        <Button
          type="primary"
          size="large"
          @click="handleSubmit('formValidate')"
          >确定</Button
        >
      </div>
    </Modal>
  </div>
</template>
<script>
export default {
  name: "CRM_addTwoIntention",
  props: [
    "addTwoIntentionShow",
    "prop_storeList",
    "prop_departmentList",
    "prop_customerGroudList",
    "prop_returnSettingList",
    "addTwoIntentionData",
    "type",
  ],
  data() {
    return {
      remoteLoading: false,
      hospitalList: [],
      loginInfo: window.agent_info,
      baseData: baseData,
      arrival_result: [],
      formItem: {
        member: {
          name: "",
          child_birth: "",
          consult_time: util.getNowFormatDate(),
          hospital: "",
          remark: "",
        },
        channel_info: {
          insert_way: "3",
          department_id: "",
          channel_id: "",
          channel_explain: "",
        },
        follow_store: [
          {
            store_id: "", //公司列表
            member_group_id: "8", //客户分组
            come_status: "1", //跟进结果
            return_setting_id: "", //到店方式,
            arrival_result_id: "",
            come_date: "",
            other: "",
          },
        ],
        follow_agent: [],
        maternal_family: [],
      },
      ruleValidate: {
        "member.name": [{ required: true, message: "请输入", trigger: "blur" }],
        "member.consult_time": [
          {
            required: true,
            type: "date",
            message: "请选择",
            trigger: "change",
          },
        ],
        "member.child_birth": [
          {
            required: true,
            type: "date",
            message: "请选择",
            trigger: "change",
          },
        ],
        "member.remark": [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        "channel_info.insert_way": [
          { required: true, message: "请选择", trigger: "change" },
        ],
        "channel_info.department_id": [
          { required: true, message: "请选择", trigger: "change" },
        ],
        "channel_info.channel_id": [
          { required: true, message: "请选择", trigger: "change" },
        ],
        "follow_store[0].member_group_id": [
          { required: true, message: "请选择", trigger: "change" },
        ],
        "follow_store[0].store_id": [
          { required: true, message: "请选择", trigger: "change" },
        ],
        "follow_store[0].come_status": [
          { required: true, message: "请选择", trigger: "change" },
        ],
      },
      channel: [],
      followDepartmentList: [],
      followr: [],
      get_follow_store_list: [], //跟进人公司列表
    };
  },
  methods: {
    apiArrivalResultList() {
      serve.fetchGet(api.arrivalResultList).then((data) => {
        this.arrival_result = data["list"];
        this.arrival_result.push({
          id: 0,
          result: "其它结果",
        });
        console.log("this.arrival_result ", this.arrival_result);
      });
    },
    //获取医院
    apiGetHospital(address) {
      serve
        .fetchGet(api.crmChildbirthHospital, { address: address })
        .then((data) => {
          console.log(data);
          let arr = [{ value: address, label: address }];
          data.result.map((item) => {
            arr.push({
              value: item.address_region,
              label: item.address_name,
            });
          });
          this.hospitalList = arr;
          // console.log('this.hospitalList',this.hospitalList)
          // console.log(' this.remoteLoading', this.remoteLoading)
          setTimeout(() => {
            this.remoteLoading = false;
          }, 200);
        })
        .catch((error) => {
          this.$Message.error(error.response.data.message);
        });
    },
    remoteMethod1(query) {},
    //医院检索
    remoteMethod(query) {
      // console.log('query remoteMethod',query)
      // console.log('hospitalList',this.hospitalList)
      this.remoteLoading = true;
      if (query !== "") {
        this.apiGetHospital(query);
      } else {
        this.hospitalList = [];
        this.remoteLoading = false;
      }
    },
    familyPhoneChange(value) {
      console.log(value);
      if (value == "") {
        this.$Message.warning("请输入家属手机号");
        return;
      }
      if (!/^1[3456789]\d{9}$/.test(value)) {
        this.$Message.warning("家属手机格式错误");
        return;
      }
    },
    //获取跟进人公司列表,根据跟进门店所选择的门店
    Es6duplicate(arr, type) {
      if (arr.length == 0) {
        return arr;
      } else {
        if (type) {
          var obj = {};
          var newArr = arr.reduce((cur, next) => {
            obj[next.name] ? "" : (obj[next.name] = true && cur.push(next));
            return cur;
          }, []);
          return newArr;
        } else {
          return Array.from(new Set(arr));
        }
      }
    },
    //获取跟进人公司列表,根据跟进门店所选择的门店
    get_follow_store() {
      let store = [];
      console.log(this.prop_storeList);
      if (this.prop_storeList.length) {
        for (let item of this.prop_storeList) {
          for (let k of this.formItem.follow_store) {
            if (item.id == k.store_id) {
              let obj = {
                id: item.id,
                name: item.name,
              };
              store.push(obj);
            }
          }
        }
      }
      this.get_follow_store_list = this.Es6duplicate(store, "name");
    },
    //监听选择跟进门店
    follow_store_change(val) {
      this.get_follow_store();
    },
    //监听跟进人门店
    changeStoreFollow(id, index, type) {
      if (type == "add") {
        this.formItem.follow_agent[index].department_id = "";
        this.formItem.follow_agent[index].follow_user = "";
        this.formItem.follow_agent[index].follow_user_data = [];
        this.followDepartmentList = [];
        this.apiDepartmentAll(id);
        return;
      }
      let url =
        this.type == "myCustomer"
          ? api.myMemberDelOrEditFollowAgent
          : api.memberDelOrEditFollowAgent;
      serve
        .fetchPut(url, {})
        .then((data) => {
          console.log(data);
          let status = data[0];
          if (status) {
            this.formItem.follow_agent[index].department_id = "";
            this.formItem.follow_agent[index].follow_user = "";
            this.formItem.follow_agent[index].follow_user_data = [];
            this.followDepartmentList = [];
            this.apiDepartmentAll(id);
          } else {
            this.$Message.warning("你没有修改跟进人的权限");
          }
        })
        .catch((error) => {
          this.$Message.error(error.response.data.message);
        });
    },
    //请求跟进人部门
    apiDepartmentAll(store_id) {
      let params = {
        store_id: store_id,
      };
      let url =
        this.type == "myCustomer"
          ? api.myMemberDepartmentAll
          : api.memberDepartmentAll;
      serve
        .fetchGet(url, params)
        .then((data) => {
          console.log(data);
          this.followDepartmentList = data.data;
          // if(detailGetData == 'detailGetData'){
          //     this.formItem.follow_agent = follow_agent
          // }
        })
        .catch((error) => {
          this.$Message.error(error.response.data.message);
        });
    },
    //监听跟进人
    changeDepartmentFollow(id, index, type) {
      if (type == "add") {
        this.formItem.follow_agent[index].follow_user = "";
        this.apiFollowr(id, this.formItem.follow_agent[index].store_id, index);
        return;
      }
      let url =
        this.type == "myCustomer"
          ? api.myMemberDelOrEditFollowAgent
          : api.memberDelOrEditFollowAgent;
      serve
        .fetchPut(url, {})
        .then((data) => {
          console.log(data);
          let status = data[0];
          if (status) {
            this.formItem.follow_agent[index].follow_user = "";
            this.apiFollowr(
              id,
              this.formItem.follow_agent[index].store_id,
              index
            );
          } else {
            this.$Message.warning("你没有修改跟进人的权限");
          }
        })
        .catch((error) => {
          this.$Message.error(error.response.data.message);
        });
    },
    //获取跟进人
    apiFollowr(department_id, store_id, index) {
      if (!department_id) {
        return;
      }
      let params = {
        department_id: department_id,
        store_id: store_id,
      };
      let url =
        this.type == "myCustomer"
          ? api.myMemberAgentAll
          : api.memberStoreMemberAgentAll;
      serve
        .fetchGet(url, params)
        .then((data) => {
          console.log("获取跟进人", data);
          this.formItem.follow_agent[index].follow_user_data = data.data;
        })
        .catch((error) => {
          // this.$Message.error(error.response.data.message);
        });
    },
    //监听选择渠道部门
    changeChannel(id) {
      this.formItem.channel_info.channel_id = "";
      this.channel = [];
      this.apiChannelAll(id);
    },
    //获取渠道
    apiChannelAll(id, detailGetData, channel_id) {
      let url =
        this.type == "myCustomer"
          ? api.myMemberChannelAll
          : api.memberStoreMemberAll;
      serve
        .fetchGet(url, { department_id: id })
        .then((data) => {
          console.log(data);
          this.channel = data.data;
          if (detailGetData) {
            this.formItem.channel_info.channel_id = channel_id;
          }
        })
        .catch((error) => {
          this.$Message.error(error.response.data.message);
        });
    },
    //添加家属
    addFamily() {
      if (this.formItem.maternal_family.length) {
        for (let item of this.formItem.maternal_family) {
          if (item.name == "" || item.relation == "" || item.phone == "") {
            this.$Message.warning("请完善家属信息");
            return;
          }
          if (!/^1[3456789]\d{9}$/.test(item.phone)) {
            this.$Message.warning("家属手机号格式错误");
            return;
          }
        }
      }
      this.formItem.maternal_family.push({
        name: "",
        relation: "",
        phone: "",
      });
    },
    //添加跟进门店
    addFollowStore() {
      if (this.formItem.follow_store.length) {
        for (let item of this.formItem.follow_store) {
          if (
            item.store_id == "" ||
            item.member_group_id == "" ||
            item.come_status == ""
          ) {
            this.$Message.warning("请完善跟进门店信息");
            return;
          }
          if (item.come_status == "2") {
            if (item.return_setting_id == "") {
              this.$Message.warning("请完善跟进门店信息");
              return;
            }
          }
        }
      }
      this.formItem.follow_store.push({
        store_id: this.loginInfo.store_id + "", //公司列表
        member_group_id: "8", //客户分组
        come_status: "1", //跟进结果
        return_setting_id: "", //到店方式
        arrival_result_id: "",
        come_date: "",
        other: "",
        type: "add",
      });
      this.get_follow_store();
    },
    //删除跟进门店
    delFollowStore(index, type) {
      if (type == "add") {
        this.formItem.follow_store.splice(index, 1);
        return;
      }
      let url =
        this.type == "myCustomer"
          ? api.myMemberDelOrEditFollowStoreGroup
          : api.memberDelOrEditFollowStoreGroup;
      serve
        .fetchPut(url, {})
        .then((data) => {
          console.log("删除跟进门店", data);
          let status = data[0];
          if (status) {
            this.formItem.follow_store.splice(index, 1);
            this.get_follow_store();
          } else {
            this.$Message.warning("您没有删除跟进门店的权限");
          }
        })
        .catch((error) => {
          this.$Message.error(error.response.data.message);
        });
    },
    //修改跟进门店
    editFollowStore(index) {
      this.apiArrivalResultList();
      let url =
        this.type == "myCustomer"
          ? api.myMemberDelOrEditFollowStoreGroup
          : api.memberDelOrEditFollowStoreGroup;
      serve
        .fetchPut(url, {})
        .then((data) => {
          console.log("修改跟进门店", data);
          let status = data[0];
          if (status) {
            this.formItem.follow_store[index].disabled = false;
          } else {
            this.$Message.warning("您没有修改跟进门店的权限");
          }
        })
        .catch((error) => {
          this.$Message.error(error.response.data.message);
        });
    },
    //添加跟进人
    addFollow() {
      let follow_agent_length = this.formItem.follow_agent.length;
      console.log(follow_agent_length);
      if (follow_agent_length) {
        for (let item of this.formItem.follow_agent) {
          if (
            item.store_id == "" ||
            item.department_id == "" ||
            item.follow_user == ""
          ) {
            this.$Message.warning("请完善跟进人信息");
            return;
          }
        }
      }
      this.formItem.follow_agent.push({
        store_id: this.prop_storeList[0].id,
        department_id: "",
        follow_user: "",
        follow_user_data: [],
        type: "add",
      });
      this.formItem.follow_agent[follow_agent_length].department_id = "";
      this.formItem.follow_agent[follow_agent_length].follow_user = "";
      this.formItem.follow_agent[follow_agent_length].follow_user_data = [];
      this.followDepartmentList = [];
      this.apiDepartmentAll(this.prop_storeList[0].id);
    },
    //删除跟进人
    delFollow(index, type) {
      if (type == "add") {
        this.formItem.follow_agent.splice(index, 1);
        return;
      }
      let url =
        this.type == "myCustomer"
          ? api.myMemberDelOrEditFollowAgent
          : api.memberDelOrEditFollowAgent;
      serve
        .fetchPut(url, {})
        .then((data) => {
          console.log("删除跟进人", data);
          let status = data[0];
          if (status) {
            this.formItem.follow_agent.splice(index, 1);
          } else {
            this.$Message.warning("您没有删除跟进人的权限");
          }
        })
        .catch((error) => {
          this.$Message.error(error.response.data.message);
        });
    },
    //修改跟进人
    editFollowInfo(index) {
      let url =
        this.type == "myCustomer"
          ? api.myMemberDelOrEditFollowAgent
          : api.memberDelOrEditFollowAgent;
      serve
        .fetchPut(url, {})
        .then((data) => {
          console.log("修改跟进人", data);
          let status = data[0];
          if (status) {
            this.formItem.follow_agent[index].disabled = false;
          } else {
            this.$Message.warning("您没有修改跟进人的权限");
          }
        })
        .catch((error) => {
          this.$Message.error(error.response.data.message);
        });
    },
    //删除家属
    delFamily(index) {
      this.formItem.maternal_family.splice(index, 1);
    },
    //确认
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          if (this.formItem.maternal_family.length) {
            for (let item of this.formItem.maternal_family) {
              if (item.name == "" || item.relation == "" || item.phone == "") {
                this.$Message.warning("请完善家属信息");
                return;
              }
              if (!/^1[3456789]\d{9}$/.test(item.phone)) {
                this.$Message.warning("家属手机号格式错误");
                return;
              }
            }
          }
          this.apiAddTwoIntention();
        } else {
          this.$Message.error("请完善表单");
        }
      });
    },
    //取消
    cancel() {
      this.$emit("addTwoIntentionEven", false);
    },
    //请求添加二次签单意向
    apiAddTwoIntention() {
      let follow_store = [];
      for (let item of this.formItem.follow_store) {
        follow_store.push({
          come_status: item.come_status,
          member_group_id: item.member_group_id,
          return_setting_id: item.return_setting_id,
          store_id: item.store_id,
          come_date: util.dateFormat(item.come_date),
          arrival_result_id: item.arrival_result_id,
          other: item.arrival_result_id == "0" ? item.other : "",
        });
      }
      let follow_agent = [];
      if (this.formItem.follow_agent.length) {
        for (let item of this.formItem.follow_agent) {
          follow_agent.push({
            store_id: item.store_id,
            department_id: item.department_id,
            follow_user: item.follow_user,
          });
          if (item.follow_user == "") {
            this.$Message.error("请完善跟进人信息");
            return;
          }
        }
      }
      let params = {
        is_twice_sign: 1,
        member: {
          id: this.addTwoIntentionData.id,
          child_birth: util.dateFormat(this.formItem.member.child_birth),
          hospital: this.formItem.member.hospital,
          name: this.formItem.member.name,
          consult_time: util.dateFormat(this.formItem.member.consult_time),
          remark: this.formItem.member.remark,
        },
        channel_info: this.formItem.channel_info,
        follow_store: follow_store,
        follow_agent: follow_agent,
        maternal_family: this.formItem.maternal_family,
      };

      let url =
        this.type == "myCustomer"
          ? api.myMemberSaveMember
          : api.memberSaveMember;
      serve
        .fetchPost(url, params)
        .then((data) => {
          console.log(data);
          this.$Message.success(data[0].message);
          this.$router.back(-1);
        })
        .catch((error) => {
          this.$Message.error(error.response.data.message);
        });
    },
  },
  watch: {
    addTwoIntentionData(data) {
      console.log("get", data);
      this.$refs.formValidate.resetFields();
      let follow_store = []; //跟进门店筛选数据
      if (data.follow_store_list.length) {
        let get_follow_store_id = [];
        for (let item of data.follow_store_list) {
          let object = {
            store_id: item.follow_store_id + "", //公司列表
            member_group_id: item.member_group_id + "", //客户分组
            come_status: item.come_status + "", //跟进结果
            return_setting_id: item.come_id + "", //到店方式
            arrival_result_id: item.arrival_result_id + "",
            come_date: item.come_date,
            other: item.other,
            disabled: true,
          };
          follow_store.push(object);
          get_follow_store_id.push(item.follow_store_id);
        }
        if (get_follow_store_id.indexOf(this.loginInfo.store_id) == -1) {
          follow_store.push({
            store_id: this.loginInfo.store_id + "", //公司列表
            member_group_id: "8", //客户分组
            come_status: "1", //跟进结果
            return_setting_id: "", //到店方式
            arrival_result_id: "",
            come_date: "",
            other: "",
            disabled: true,
          });
        }
      } else {
        follow_store.push({
          store_id: this.loginInfo.store_id + "", //公司列表
          member_group_id: "8", //客户分组
          come_status: "1", //跟进结果
          return_setting_id: "", //到店方式
          arrival_result_id: "",
          come_date: "",
          other: "",
          disabled: true,
        });
      }
      let follow_agent = []; //跟进人筛选数据
      if (data.follow_list.length) {
        let index = 0;
        for (let item of data.follow_list) {
          let obj = {
            store_id: item.store_id, //公司
            department_id: item.follow_department_id, //部门
            follow_user: item.follow_user_id, //人员
            disabled: true,
            follow_user_data: [],
          };
          follow_agent.push(obj);
          this.apiDepartmentAll(item.store_id);
          this.apiFollowr(item.follow_department_id, item.store_id, index);
          index++;
        }
      }

      let maternal_family = []; //家属筛选数据
      if (data.maternal_info_list.length) {
        if (data.maternal_info_list[0].maternal_family_list.length) {
          for (let item of data.maternal_info_list[0].maternal_family_list) {
            maternal_family.push({
              name: item.name, //姓名
              relation: item.relation, //关系
              phone: item.phone, //电话
            });
          }
        }
      }

      this.formItem.member.name = data.name;
      this.formItem.channel_info.department_id =
        data.channel_info_list[0].department_id + "";
      this.apiChannelAll(
        data.channel_info_list[0].department_id,
        "detailGetData",
        data.channel_info_list[0].channel_id + ""
      );

      this.formItem.channel_info.channel_explain =
        data.channel_info_list[0].channel_explain;
      this.formItem.follow_store = follow_store;
      this.formItem.member.maternal_family = maternal_family;
      this.formItem.follow_agent = follow_agent;
      this.get_follow_store();
    },
  },
};
</script>
<style scoped>
.title {
  padding-top: 10px;
  height: 32px;
  padding-bottom: 10px;
  margin-bottom: 10px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.ivu-modal {
  top: 0;
}
</style>



// WEBPACK FOOTER //
// src/commonTmp/CRM/CRM_addTwoIntention.vue